module.exports = __webpack_public_path__ + "static/media/network.b4c5f0ba.svg";